import React, { useContext } from "react";
// React Bootstrap
import { Button, Accordion, Card } from "react-bootstrap";
// Componentes
import VistaDescripcion from "../vistas/VistaDescripcion";
import FormDescripcion from "../formularios/FormDescripcion";
// Contexto
import { ModalContext } from "../../../context/modalContext";

const Descripcion = ({ descripcion, handlePutDatosComunidad }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);

  return (
    <Accordion defaultActiveKey="1">
      <Card>
        <Card.Header>
          <Accordion.Toggle eventKey="0" as={Button} variant="link">
            Descripción
          </Accordion.Toggle>
          <Button
            variant="outline-primary"
            size="sm"
            className="float-right mr-4"
            onClick={() => {
              modalSetShow(true, "80%");
              modalSetTitle("Editar descripción");
              modalSetContent(<FormDescripcion defaultValues={{ missionDescription: descripcion }} submissionHandler={handlePutDatosComunidad} />);
            }}
          >
            Editar
          </Button>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body className={"bg-light"}>
            <VistaDescripcion descripcion={descripcion} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default Descripcion;
